import { environment } from '@env/environment';

import { DeviceType, OsType, detectDevice } from '@personal-area/global/browser-detection';

export class PlatformsLinks {
  public links = environment.metaTraderLinks;
  public device = detectDevice(navigator.userAgent);
  public mt4link = this._setLink('mt4');
  public mt5link = this._setLink('mt5');

  private _setLink(type: 'mt4' | 'mt5'): string {
    return this.device.type === DeviceType.desktop
      ? this.device.os === OsType.mac
        ? this.links.mac[type]
        : this.links.windows[type]
      : this.device.type === DeviceType.ios
        ? this.links.ios[type]
        : this.links.android[type];
  }
}
